"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PrintButtonArea;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var PrintButton_1 = __importDefault(require("./PrintButton"));
var usePrintButtonArea_1 = require("../hooks/usePrintButtonArea");
function PrintButtonArea(_a) {
    var _b;
    var queryClient = _a.queryClient, areaIdentifier = _a.areaIdentifier, printRequestParams = _a.printRequestParams, locale = _a.locale, _c = _a.options, options = _c === void 0 ? {} : _c, fileName = _a.fileName, handleBlob = _a.handleBlob;
    var _d = (0, usePrintButtonArea_1.usePrintButtonArea)(queryClient, (_b = options.docServerBasePath) !== null && _b !== void 0 ? _b : "", areaIdentifier), printButtonArea = _d.printButtonArea, isLoading = _d.isLoading, isError = _d.isError, error = _d.error;
    if (isLoading) {
        return (react_1.default.createElement(material_1.Box, { sx: options.areaSx },
            react_1.default.createElement(material_1.CircularProgress, null)));
    }
    if (isError) {
        return (react_1.default.createElement(material_1.Alert, { severity: "error" }, "Error fetching PrintButtonArea: ".concat((error === null || error === void 0 ? void 0 : error.message) || "An unexpected error occurred")));
    }
    return (react_1.default.createElement(material_1.Box, { sx: options.areaSx }, printButtonArea === null || printButtonArea === void 0 ? void 0 : printButtonArea.printButtons.map(function (button) { return (react_1.default.createElement(PrintButton_1.default, { key: button.id, button: button, printData: { printRequestParams: printRequestParams, locale: locale, fileName: fileName }, options: options, handleBlob: handleBlob })); })));
}
